import {
  confirmResetPassword,
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
  resetPassword,
  signIn,
  signOut,
} from 'aws-amplify/auth'

const Auth = {
  async currentSession() {
    const session = await fetchAuthSession()
    const idToken = session.tokens?.idToken
    if (!idToken) throw new Error('No authenticated session')

    return {
      getIdToken: () => ({
        decodePayload: () => idToken.payload as any,
        getJwtToken: () => idToken.toString(),
      }),
    }
  },
  async currentUserInfo() {
    const [user, attributes] = await Promise.all([
      getCurrentUser(),
      fetchUserAttributes(),
    ])
    return { ...user, id: user.userId, attributes }
  },
  async signIn(username: string, password: string) {
    const result = await signIn({ username, password })
    return {
      ...result,
      challengeName:
        result.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED'
          ? 'NEW_PASSWORD_REQUIRED'
          : undefined,
    }
  },
  signOut,
  forgotPassword(username: string) {
    return resetPassword({ username })
  },
  forgotPasswordSubmit(username: string, confirmationCode: string, newPassword: string) {
    return confirmResetPassword({ username, confirmationCode, newPassword })
  },
}

export default Auth
